<template>
  <v-dialog :value="value" @input="$emit('input', $event)" :max-width="isMobile ? '100%' : '1600'">
    <v-card class="text-center mx-auto">
      <v-toolbar flat outlined>
        <v-toolbar-title>
          <v-icon color="primary" left size="x-large">mdi-heart-pulse</v-icon>
          Realizar Triagem
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <soi-dados-padrao-triagem
        ref="modalTriagem"
        :mostrarBotoes="true"
        :modalTriagem="value"
        :rotaModalAgendamento="'ModalAgendamento'"
        @triagemSalva="onTriagemSalva"
        @atualizaCalendario="$emit('atualizaCalendario')"
      />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ModalTriagem',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    idAgendamento: {
      type: Number,
      default: 0,
    },
    idPaciente: {
      type: Number,
      default: 0,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newValue: boolean) {
      if (newValue && this.idAgendamento && this.idPaciente) {
        this.$nextTick(async () => {
          if (this.$refs.modalTriagem && (this.$refs.modalTriagem as any).carregarTriagemNoAgendamento) {
            await (this.$refs.modalTriagem as any).carregarTriagemNoAgendamento(
              this.idAgendamento,
              this.idPaciente,
            );
          }
        });
      }
    },
  },
  methods: {
    fechar() {
      this.$emit('input', false);
    },
    onTriagemSalva() {
      this.$emit('triagemSalva');
      this.$emit('input', false);
    },
  },
});
</script>

